import styled from "styled-components";

export const Styles = styled.div<{ isMobileOrTablet?: boolean }>`
  ${({ isMobileOrTablet }) =>
    isMobileOrTablet &&
    `
      flex: 1;
  .title {
    font-size: 24px;
    margin: 0;
    margin-bottom: 12px;
    color: var(--text-color);
  }
  .item-clock-history {
    background: var(--bg-item);
    margin-bottom: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 52px;
    padding: 0 12px;
    border-radius: 8px;
    .clock-date {
      font-weight: 700;
    }
  }
  .clock-time {
    min-width: 120px;
    text-align: center;
  }

    `}
  ${({ isMobileOrTablet }) =>
    !isMobileOrTablet &&
    `
  background: #ebebeb;
  padding: 24px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  margin-top: 24px;
   `}

  .change-month {
    width: 300px;
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    line-height: 24px;
    color: #1e3666;

    button {
      background: none;
      border: none;
      padding: 0px;
      border-radius: 0px;
      font-size: 24px;
    }

    .pre {
      color: #1e3666;
    }
    .next {
      transform: rotate(180deg);
      color: #1e3666;
    }
    .disabled {
      color: #d9d9d9;
      cursor: not-allowed;
    }
  }
  .attendance-management-btn {
    border-radius: 4px;
    height: 36px;
    color: #fff;
    background: #2b3864;
    font-weight: 700;
    font-size: 16px;
    width: 240px;
  }

  .date-btn {
    border-radius: 4px;
    height: 36px;
    color: #fff;
    background: #4e525b;
    font-weight: 700;
    font-size: 16px;
    width: 120px;
    margin-top: 8px;
  }

  .table-fixed {
    table-layout: fixed !important;
    width: 100%;
    .border-bottom-tr {
      border-bottom: 1px solid #d9d9d9;
      height: 28px;
      th {
        font-size: 16px;
        line-height: 24px;
      }
    }
    .text-center {
      text-align: center;
    }
    .fs-16 {
      font-size: 16px;
    }
    .text-right {
      text-align: right;
    }

    .attendance-modify-btn {
      border-radius: 4px;
      height: 34px;
      background-color: #1e3666;
      border: 1px solid #1e3666;
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      width: 110px;
    }
  }
  .h-100 {
    height: 100px;
  }
`;
